import React, { useContext } from "react";

import t from "module/translations";
import MaintenanceTaskContext from "module/maintenanceTask/context/MaintenanceTaskContext";
import { MaintenanceTaskInterface } from "module/maintenanceTask/types";
import Caption from "component/caption/Caption";
import XLabelField from "component/labelField/XLabelField";

const PreviousMaintenanceTaskContainer: React.FC = () => {
  const { entity } = useContext(MaintenanceTaskContext);
  const maintenanceTask = entity as MaintenanceTaskInterface;

  const { previousMaintenanceTask } = maintenanceTask;

  if (!previousMaintenanceTask || previousMaintenanceTask.remarks === "") {
    return null;
  }

  return (
    <div>
      <Caption {...{ text: t.maintenanceTask.previousMaintenanceTaskText }} />
      <div>
        <XLabelField
          {...{
            label: previousMaintenanceTask.remarks,
            // caption: t.maintenanceTask.remarksText,
          }}
        />
      </div>
    </div>
  );
};

export default React.memo(PreviousMaintenanceTaskContainer);
